function t(n) {
  return function(r) {
    return n(r);
  };
}
export {
  t as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_baseUnary.js
// module id = 460
// module chunks = 67